import { render, staticRenderFns } from "./report-manager.vue?vue&type=template&id=0798b7ea&scoped=true&"
import script from "./report-manager.vue?vue&type=script&lang=js&"
export * from "./report-manager.vue?vue&type=script&lang=js&"
import style0 from "./report-manager.vue?vue&type=style&index=0&id=0798b7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0798b7ea",
  null
  
)

export default component.exports